import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import EmblaCarousel from '../emblaCarousel'
import { useScreenWidth } from '../../hooks/use-screen-width'
import { getResponsiveTileShowCount } from '../../lib/utils'
import CarouselTile from '../carousel/tile'
import styles from './title-list.css'

const TABS = {
  recommendedTiles: 'recommendedTiles'
}
const TABS_LABELS = {
  recommendedTiles: 'YOU MAY ALSO LIKE'
}

function TitleList({
  title,
  isContentItemOnMyList,
  addToMyList,
  removeFromMyList,
  theme,
  margin
}) {
  const [selectedTab, setSelectedTab] = useState(TABS.recommendedTiles)
  const screenWidth = useScreenWidth()
  const tilesShowCount = getResponsiveTileShowCount(screenWidth, 2)

  const recommendedTiles = title?.recommendedTiles || []
  if (!recommendedTiles.length) {
    return null
  }

  return (
    <div className={styles.titleListWrapper}>
      <div
        className={styles.titleListTabWrapper}
        style={{
          marginLeft: margin,
          marginRight: margin
        }}
      >
        <span className={styles.breakline} />

        <div
          className={classNames(styles.tab, {
            [styles.active]: TABS.recommendedTiles === selectedTab
          })}
          onClick={() => { setSelectedTab(TABS.recommendedTiles) }}
        >
          {TABS_LABELS[TABS.recommendedTiles]}
        </div>
      </div>

      <EmblaCarousel
        slidesToShow={tilesShowCount}
        activeSlideCount={recommendedTiles.length}
      >
        {recommendedTiles.map((tile, index) => {
          return (
            <div
              className={styles.emblaSlide}
              key={tile.id}
            >
              <CarouselTile
                tile={tile}
                theme={theme}
                index={index}
                contentType="Title"
                listTitle="You May Also Like"
                addToMyList={addToMyList}
                removeFromMyList={removeFromMyList}
                isOnMyList={isContentItemOnMyList(tile.contentItem.id)}
              />
            </div>
          )
        })}
      </EmblaCarousel>
    </div>
  )
}

TitleList.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isContentItemOnMyList: PropTypes.func.isRequired,
  addToMyList: PropTypes.func.isRequired,
  removeFromMyList: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  margin: PropTypes.number.isRequired
}

export default TitleList
